import $ from 'jquery'
import store_finance from '@/store/mods/finances/finance.js'

export default {
    name: 'examen-para-modal',
    components: {},
    props: {
        is_new_bulletin: Boolean,
        selected_bulletin: Object,
        evolution_id: Number,
        consultation: Object,
        user_id: Number,
        examen_to_be_deleted: Object,
        info_patient: Object,
        info_caissier: Object
    },
    data() {
        return {
            loading: false,
            prix_is_not_set: false,
            examen_checked: [],
            checked_is_empty: false,

            is_demande: true.valueOf,

            nouvel_examen: {
                libelle: '',
                prix: ''
            },
            e_loading: false,
            is_added: false,
            btn_disable: false,

            del_loading: false,
            is_confirm: false,

            can_show_examen: false,
            can_save: false,
            choix_type_demande: 'interne',

            save_loading: false,
            renseignement_clinique: '',
            is_error: false,
            permission_is_denied: false,
            patient_id: '',

            error_message: '',

            filter_examen: '',
            filtered_examens: [],
            exm_is_loading: true,
            exm_is_empty: false
        }
    },

    watch: {
        selected_bulletin() {
            console.log(this.selected_bulletin);
            this.permission_is_denied = false
            this.is_error = false
            this.renseignement_clinique = this.selected_bulletin.renseignement_clinique
            this.is_confirm = false
    
            let cfrm = document.getElementById('cfrm-del-bull') 
            if (cfrm && cfrm.checked) {
                cfrm.checked = false
            }
        },

        examen_to_be_deleted() {
            this.permission_is_denied = false
            this.is_error = false
            this.is_confirm = false
        },

        filter_examen() {
            this.filterExamen()
        },

        examen_checked() {
            this.choice_is_empty = false
        },
    },

    computed: {
        types_examens() {
            return this.$store.getters["examens"];
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },

    mounted() {
        this.fetchExamen()

        this.user_id = this.userCredentials.id
        this.patient_id = this.$route.params.id
    },

    methods: {
        fetchExamen() {
            this.exm_is_loading = true
            this.$store.dispatch("getExamens").then(() => {
                if (this.types_examens.length == 0) {
                    this.exm_is_empty = true
                } else {
                    this.exm_is_empty = false
                    this.filtered_examens = this.types_examens
                }

                this.exm_is_loading = false
            })
        },

        filterExamen() {
            this.filtered_examens = [];

            if (this.filter_examen == '') {
                this.filtered_examens = this.types_examens
            } else {
                this.types_examens.forEach(examen => {
                    let cleaned_examen = this.removeAccents(examen.nom)
                    let cleaned_filter = this.removeAccents(this.filter_examen)

                    if (cleaned_examen.toLowerCase().includes(cleaned_filter.toLowerCase())) {
                        this.filtered_examens.push(examen)
                    }
                });
            }
        },

        onChoice(value) {
            if (value == 1) {
                this.can_show_examen = true
            } else {
                this.can_show_examen = false
            }
            
        },

        addNouvelExamen() {
            this.is_demande = false
        },

        retour() {
            this.is_demande = true

            $('.err-msg').fadeOut()
        },

        clickOnExamen() {
            this.prix_is_not_set = true
            setTimeout(() => {
                this.prix_is_not_set = false
            }, 2000);
        },

        onExamChange() {
            this.checked_is_empty = false
        },

        toggleRenseignement(v) {
            if (v) {
                if (this.examen_checked.length == 0) {
                    this.checked_is_empty = true
                    return
                }
            }

            this.can_save = v
        },

        checkIfExistInBulletin() {
            this.selected_bulletin.examens.forEach(examen => {
                const bull = this.examen_checked.filter((el) => {
                    return el.id != examen.type_examen_id
                })

                this.examen_checked = bull
            });
        },

        async submit() {
            if (this.$refs.exm_renseign_form) {
                const isValid = await this.$refs.exm_renseign_form.validate();

                if (!isValid) {
                    return
                }
            }

            if (!this.is_new_bulletin) {
                /**
                 * Deselectionner les examen déjà existants
                 */
                this.checkIfExistInBulletin()
            }

            if (this.examen_checked.length == 0) {
                this.checked_is_empty = true
                return
            }

            this.examen_checked = this.setPrestationUID(this.examen_checked)

            const data = {
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                examen_selectionnes: this.examen_checked,
                user_id: this.user_id,
                patient_id: this.consultation.patient_id,
                choix_type_demande: this.choix_type_demande, 
                renseignement_clinique: this.renseignement_clinique,
                bulletin_id: this.selected_bulletin.bulletin_id,
                type_prestation: 'Examens',
                can_set_pac: this.can_set_pac,
                info_caissier: this.info_caissier,
                info_patient: this.info_patient,
                nom_patient: this.info_patient.nom_patient,
                sexe: this.info_patient.sexe,
                telephone: this.info_patient.telephone,
                prescripteur: {
                    nom: this.userCredentials.name,
                    titre: this.userCredentials.titre
                }
            }

            this.save_loading = true
            console.log(data);

            this.$store.dispatch('saveDemandeExamen', data).then((response) => {
                if (response.success) {
                    this.successToast('Ajout effectué avec succès')
                    this.$emit('updateDemandeExamenPara')
                    this.renseignement_clinique = ''
                    this.examen_checked = []
                    this.can_save = false

                    if (this.$refs.exm_renseign_form) {
                        this.$refs.exm_renseign_form.reset()
                    }
                    
                    this.$refs.bul_imagerie.click()

                    store_finance.storeLigneOperation(response.data).then((finance_response) => {
                        if (!finance_response.success) {
                            this.errorToast(finance_response.message)
                            return;
                        } 
                    }).catch(() => {
                        this.errorToast("Une erreur s'est produite lors de l'enregistrement à la caisse")
                    })
                } else {
                    if (response.code === 500) {
                        this.is_error = true
                    } else if (response.code === 403) {
                        this.permission_is_denied = true
                    }
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
            })
            
        },

        async saveRenseignementClinique() {
            const isValid = await this.$refs.renseign_exm_form.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true

            let data = {
                consultation_id: this.consultation.id,
                evolution_id: this.selected_bulletin.evolution_id,
                bulletin_id: this.selected_bulletin.bulletin_id,
                renseignement_clinique: this.renseignement_clinique,
                user_id: this.user_id,
            }

            this.$store.dispatch('editExamenRenseignementClinique', data).then((response) => {
                if (response > 0) {
                    this.renseignement_clinique = ''
                    this.$refs.renseign_exm_form.reset()
                    this.$refs.edit_renseign_exm.click()

                    this.$emit("updateDemandeExamenPara")
                } else {
                    if (response === -1) {
                        this.is_error = true
                    } else if (response === -2) {
                        this.permission_is_denied = true
                    }
                }

                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
            })
        },

        doWarningMsg: function(msg) {
            if (this.$toasted != null) this.$toasted.clear()
            this.$toasted.show(msg, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'bottom-center',
                duration: 2000,
                theme: 'toasted-warning',
                type: 'warning'
            })
        },

        /**
         * Ajouter un nouvel examen paraclinique
         */
        async addNNewExam() {
            const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }

            this.e_loading = true
            this.btn_disable = true

            this.$store.dispatch("addNewExamen", this.nouvel_examen).then((response) => {
                this.e_loading = false
                this.btn_disable = false
                if (response > 0) {
                    this.is_added = true
                    this.$store.dispatch("getExamens");
                    this.is_demande = true
                    
                    this.nouvel_examen = {
                        libelle: '',
                        prix: ''
                    }
                } else {
                    $('.err-msg').fadeIn(500)
                }
            })
        },

        clearError() {
            $('.err-msg').fadeOut()
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

		/**
		 * Retirer un examen de la liste de demande
		 */
        deleteExamen(selector) {
            const confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true
            
            this.$store.dispatch('deleteDemandeExamen', this.examen_to_be_deleted).then((response) => {
                if (response.success) {
                    this.successToast('Suppression effectuée avec succès')
                    this.$emit("updateDemandeExamenPara")

                    this.$refs.del_examen.click()

                    store_finance.removeItemFromCaisse(response.data).then((finance_response) => {
                        if (!finance_response.success) {
                            this.errorToast(finance_response.message)
                            return;
                        } 
                    }).catch(() => {
                        this.errorToast("Une erreur s'est produite lors de l'enregistrement à la caisse")
                    })
                } else {
                    if (response.code == 403) {         // Permission denied
                        this.error_message = "Impossible de supprimer"
                    } else if (response.code == 409) {
                        this.error_message = "Impossible de supprimer"
                    } else if (response.code == 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                
                this.del_loading = false;
                this.is_confirm = false
            }).catch(() => {
                this.del_loading = false
                this.error_message = "Une erreur s'est produite !"
            })
        },

        deleteBulletinExamen(selector) {
            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }
            let data = {
                consultation_id: this.consultation.id,
                bulletin_id: this.examen_to_be_deleted.bulletin_id,
                user_id: this.user_id,
            }
            console.log(data);
            this.del_loading = true;
            this.$store.dispatch('deleteExamenBulletin', data).then((response) => {
                if (response.success) {
                    this.successToast("Suppression effectuée avec succès")
                    this.$emit("updateDemandeExamenPara")

                    this.is_confirm = false
                    this.$refs.del_bulletin_exm.click();

                    store_finance.removeAllItemsFromCaisse(response.data).then((finance_response) => {
                        if (!finance_response.success) {
                            this.errorToast(finance_response.message)
                            return;
                        } 
                    }).catch(() => {
                        this.errorToast("Une erreur s'est produite lors de l'enregistrement à la caisse")
                    })
                } else {
                    if (response.code == 403) {         // Permission denied
                        this.error_message = "Impossible de supprimer"
                    } else if (response.code == 409) {
                        this.error_message = "Impossible de supprimer"
                    } else if (response.code == 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                this.del_loading = false
            }).catch(() => {
                this.del_loading = false
                this.error_message = "Une erreur s'est produite !"
            })
        },
    }
}